import type { RealtimeTransportIdentity } from '@repo/sdk'
import { isRegisteredAccount } from '@repo/sdk'

export function canHoldStream(
  userInfo: RealtimeTransportIdentity | null | undefined,
  authResolved: boolean,
): boolean {
  if (!authResolved)
    return false
  return isRegisteredAccount(userInfo)
}
